import React from 'react';
import type { ClientInvoiceViewModel } from '../../lib/clientInvoiceTemplate';
import XCircleIcon from '../icons/XCircleIcon';
import ClientInvoicePrintDocument from './ClientInvoicePrintDocument';

interface ClientInvoicePreviewModalProps {
  viewModel: ClientInvoiceViewModel;
  onClose: () => void;
  onDownloadPdf?: () => void;
  downloading?: boolean;
}

const ClientInvoicePreviewModal: React.FC<ClientInvoicePreviewModalProps> = ({
  viewModel: vm,
  onClose,
  onDownloadPdf,
  downloading = false,
}) => {
  return (
    <div className="fixed inset-0 z-[60] flex items-center justify-center bg-black/50 p-4">
      <div className="flex max-h-[92vh] w-full max-w-3xl flex-col overflow-hidden rounded-xl bg-white shadow-2xl">
        <div className="flex items-center justify-between border-b px-5 py-3">
          <h2 className="text-lg font-bold text-gray-900">Invoice preview</h2>
          <button type="button" onClick={onClose} aria-label="Close preview">
            <XCircleIcon className="h-7 w-7 text-gray-500" />
          </button>
        </div>

        <div className="flex justify-center overflow-y-auto p-5">
          <div className="overflow-hidden rounded-lg border border-gray-200 bg-white shadow-sm">
            <ClientInvoicePrintDocument viewModel={vm} />
          </div>
        </div>

        <div className="flex justify-end gap-3 border-t bg-gray-50 px-5 py-3">
          <button type="button" onClick={onClose} className="rounded-md bg-gray-200 px-4 py-2 text-gray-800">
            Close
          </button>
          {onDownloadPdf ? (
            <button
              type="button"
              disabled={downloading}
              onClick={onDownloadPdf}
              className="rounded-md bg-pink-600 px-4 py-2 text-white disabled:opacity-60"
            >
              {downloading ? 'Preparing PDF…' : 'Download PDF'}
            </button>
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default ClientInvoicePreviewModal;
